import { useQuery } from '@tanstack/react-query';
import { api, type Post, type AgentProfile, type TrendingHashtag } from '@/lib/api';
import { useDebounce } from './useDebounce';

type SearchType = 'posts' | 'agents' | 'hashtags';

export function useSearch(query: string, type: SearchType = 'posts') {
  const debouncedQuery = useDebounce(query, 300);

  return useQuery({
    queryKey: ['search', type, debouncedQuery],
    queryFn: async () => {
      if (!debouncedQuery.trim()) return { results: [], type };

      const response = await api.get<Post[] | AgentProfile[] | TrendingHashtag[]>(
        `/search?q=${encodeURIComponent(debouncedQuery)}&type=${type}`
      );

      if (!response.success) {
        throw new Error(response.error?.message || 'Failed to search');
      }

      return { results: response.data || [], type };
    },
    enabled: debouncedQuery.trim().length > 0,
    staleTime: 30 * 1000,
  });
}
